"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormatPoints = useFormatPoints;
var _formatters = require("../formatters");
var _useCulture = require("./useCulture");
/**
 * Returns parameter `value` formatted as the points (Loyalty and other points).
 * @see {@link formatPoints} for more information.
 *
 * @param value Numeric value to format
 * @returns `value` formatted as the points
 * @example
  // basic usage
  useFormatPoints(1234.567)
 */
function useFormatPoints(value) {
  const {
    culture
  } = (0, _useCulture.useCulture)();
  return (0, _formatters.formatPoints)(value, culture);
}
//# sourceMappingURL=useFormatPoints.js.map